
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

const FINISHED_STATUSES = [
  "selesai",
  "batal",
  // status rilis lama
  "pulang_rumah",
  "pulang_paksa",
  "dirujuk",
  "meninggal",
  "pindah_ruang"
];

interface IgdIndicator {
  admitted_at: string | null;
  first_assessment_at: string | null;
  discharge_at: string | null;
  serah_terima_at?: string | null;
  response_min: number | null;
  target_response_min: number;
  target_los_min: number;
  status: string;
  los_running?: boolean;
  register_closed?: boolean;
}

@Component({})
export default class IgdTimelineCell extends Vue {
  @Prop({ required: true }) readonly indicator!: IgdIndicator | null;

  now: number = Date.now();
  expanded = false;
  private tickHandle: number | null = null;

  mounted() {
    // Tick tiap 30 detik untuk update LOS pasien yang masih di IGD. Pasien
    // "menunggu_ruang" masih dihitung berada di IGD, jadi jamnya tetap jalan.
    this.tickHandle = window.setInterval(() => {
      if (this.isStillInIgd) {
        this.now = Date.now();
      }
    }, 30_000);
  }

  beforeDestroy() {
    if (this.tickHandle !== null) {
      window.clearInterval(this.tickHandle);
      this.tickHandle = null;
    }
  }

  toggleDetail() {
    this.expanded = !this.expanded;
  }

  /** Pasien sudah keluar IGD → baris IN/DPJP/OUT diringkas. */
  get canCollapse(): boolean {
    return !!this.indicator && !this.isStillInIgd;
  }

  get showDetail(): boolean {
    return !this.canCollapse || this.expanded;
  }

  /**
   * Sumber utama: flag `los_running` dari backend. Fallback dipakai untuk payload
   * rilis lama yang belum punya flag itu.
   */
  get isStillInIgd(): boolean {
    const ind = this.indicator;
    if (!ind) return false;
    if (typeof ind.los_running === "boolean") return ind.los_running;

    if (ind.discharge_at || ind.serah_terima_at) return false;

    return FINISHED_STATUSES.indexOf(ind.status) === -1;
  }

  get outAt(): string | null {
    const ind = this.indicator;
    if (!ind) return null;
    if (ind.discharge_at) return ind.discharge_at;
    // pasien ranap: jam keluar IGD = jam transfer internal ke bangsal
    return this.isStillInIgd ? null : ind.serah_terima_at || null;
  }

  get outIsHandover(): boolean {
    return !!this.outAt && !(this.indicator && this.indicator.discharge_at);
  }

  fmtTime(iso: string | null | undefined): string {
    if (!iso) return "—";
    const m = moment(iso);
    return m.isValid() ? m.format("HH:mm") : "—";
  }

  get admittedDate(): string | null {
    if (!this.indicator?.admitted_at) return null;
    const m = moment(this.indicator.admitted_at);
    if (!m.isValid()) return null;
    // hanya tampilkan tanggal kalau bukan hari ini
    return m.isSame(moment(), "day") ? null : m.format("DD/MM");
  }

  get responseMin(): number | null {
    return this.indicator?.response_min ?? null;
  }

  get targetResponseMin(): number {
    return this.indicator?.target_response_min ?? 5;
  }

  get responseColor(): string {
    if (this.responseMin === null) return "grey";
    return this.responseMin <= this.targetResponseMin ? "green" : "red";
  }

  get losMin(): number | null {
    if (!this.indicator?.admitted_at) return null;
    const start = moment(this.indicator.admitted_at);
    if (!start.isValid()) return null;

    const end =
      this.outAt && !this.isStillInIgd ? moment(this.outAt) : moment(this.now);
    if (!end.isValid()) return null;

    return Math.max(0, end.diff(start, "minutes"));
  }

  get losText(): string {
    if (this.losMin === null) return "—";
    const h = Math.floor(this.losMin / 60);
    const m = this.losMin % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  }

  get losTargetText(): string {
    const t = this.indicator?.target_los_min ?? 480;
    const h = Math.floor(t / 60);
    return `${h}j`;
  }

  get losColor(): string {
    if (this.losMin === null) return "grey";
    // KARS ≤ 6 jam = ideal, Permenkes ≤ 8 jam = batas.
    if (this.losMin <= 360) return "green";
    if (this.losMin <= 480) return "orange darken-2";
    return "red";
  }
}
